import { convertDateStringtoMoment, formFlagToBoolean } from '@/utilz';
import { getLocalDateTime } from '@/utils/date';

import type { OCClaimInitialValuesResponse } from './api';

export const normalizeOCClaimInitialValues = (data: OCClaimInitialValuesResponse) => {
  if (!data) {
    return null;
  }
  return {
    ammendmentDate: convertDateStringtoMoment(data?.ammendmentDate) ?? undefined,
    auditedBy: data?.auditedBy,
    bolAttach: formFlagToBoolean(data?.bolAttach),
    carrierClaimNo: data?.carrierClaimNo,
    carrierDisplayAddress: data?.carrierDisplayAddress ? data?.carrierDisplayAddress : '',
    carrierEmail: data?.carrierEmail,
    carrierKey: data?.carrierKey ? data?.carrierKey : undefined,
    carrierName: data?.carrierName,
    checkDateToCustomer: convertDateStringtoMoment(data?.checkDateToCustomer) ?? undefined,
    checkNoFromCarrier: data?.checkNoFromCarrier,
    checkNoToCustomer: data?.checkNoToCustomer,
    closedDate: convertDateStringtoMoment(data?.closedDate) ?? undefined,
    currencyCode: data?.currencyCode,
    customerClaimNo: data?.customerClaimNo,
    customerDisplayAddress: data?.customerDisplayAddress,
    customerName: data?.customerName,
    dateSubmitted: getLocalDateTime().toISOString(),
    fbAttach: formFlagToBoolean(data?.fbAttach),
    invAttach: formFlagToBoolean(data?.invAttach),
    ocTypeKey: data?.ocTypeKey ? data?.ocTypeKey : undefined,
    otherAttach: formFlagToBoolean(data?.otherAttach),
    otherDesc: data?.otherDesc,
    preparedBy: data?.preparedBy,
    reasonCode: data?.reasonCode,
    recoverySum: data?.recoverySum,
    statusCode: data?.statusCode,
    submittedBy: data?.submittedBy,
  };
};
